import { useCallback, useState } from 'react'

import { Text } from '@wartek-id/text-v1'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import { Header } from 'app/KinerjaShared/components/Header'
import TablePelaksanaanPS from './TablePelaksanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import usePelaksanaanList from 'app/KinerjaTimPenilaiPSPage/hooks/usePelaksanaanList'

import type {
  PelaksanaanPSListFilterState,
  TPelaksanaanPSListSummary,
} from 'types/kinerja-tim-penilai-ps'

const FILTER_STATE: Record<PelaksanaanPSListFilterState, string> = {
  SEMUA: 'Semua',
  SELESAI_PRAKTIK_KINERJA: 'Selesai Praktik Kinerja',
  SELESAI_PERILAKU_KERJA: 'Selesai Perilaku Kerja',
  SELESAI_PENGEMBANGAN_KOMPETENSI: 'Selesai Pengembangan Kompetensi',
  SELESAI_SEMUA_KEGIATAN: 'Selesai Semua',
}

const mapping: Record<
  PelaksanaanPSListFilterState,
  keyof TPelaksanaanPSListSummary
> = {
  SEMUA: 'total',
  SELESAI_PRAKTIK_KINERJA: 'selesaiPraktikKinerja',
  SELESAI_PERILAKU_KERJA: 'selesaiPerilakuKerja',
  SELESAI_PENGEMBANGAN_KOMPETENSI: 'selesaiPengembanganKompetensi',
  SELESAI_SEMUA_KEGIATAN: 'selesaiSemuaKegiatan',
}

export default function DaftarPenilaianPelaksanaanPS() {
  const { basePath, isPPKPengawasSekolahUrl } = useBasePath()

  const [activeFilterState, setActiveFilterState] =
    useState<PelaksanaanPSListFilterState>('SEMUA')
  const { summary, data, isLoading, isFetched } = usePelaksanaanList({
    filter: activeFilterState,
  })

  const handleStateChange = useCallback(
    (state: PelaksanaanPSListFilterState) => {
      setActiveFilterState(state)
    },
    []
  )

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header
        title={`${
          isPPKPengawasSekolahUrl ? 'Penilaian' : 'Pemantauan'
        } Kinerja`}
        className="mt-6"
      />
      <div className="mt-12 bg-white border rounded border-gray-30">
        <div className="p-6 pb-0 space-y-1">
          <Text variant="heading-md" as="h2">
            Lakukan {isPPKPengawasSekolahUrl ? 'Penilaian' : 'Pemantauan'} serta
            cek status Praktik Kinerja dan Perilaku Kerja
          </Text>
        </div>

        <div className="p-6">
          {isFetched && (
            <FilterButtons
              activeValue={activeFilterState}
              className="flex-wrap"
              onChange={handleStateChange}
              items={Object.keys(FILTER_STATE).map((state) => ({
                label: `${FILTER_STATE[state]} (${
                  summary[mapping[state as keyof typeof mapping]]
                })`,
                value: state as PelaksanaanPSListFilterState,
              }))}
            />
          )}
        </div>

        <TablePelaksanaanPS
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
